import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const Privacy = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.lgpdPrivacy')} />;
};

export default Privacy;
